import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildTrainingRequestsDatatableFilter,
  useTrainingRequestsDatatable,
} from 'generated/resources/datatable.graphql'
import { CompetencyFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const competenciesFilter = (
  source: ReturnType<typeof useTrainingRequestsDatatable>,
  competencies: CompetencyFragment[]
) => {
  const options = competencies.map((competency) => {
    return {
      label: competency.name,
      value: competency.id,
      component: (
        <Box flexDirection="row" alignItems="center" gap="s8">
          <Text.Normal weight="medium">{competency.name}</Text.Normal>
        </Box>
      ),
    }
  })

  return buildTrainingRequestsDatatableFilter(source, {
    type: FilterType.Integer,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'competenciesFilter',
    path: 'competencyId',
    title: i18n.t('trainings.trainings_table.competencies'),
  })
}
